import React, { FC, useEffect } from 'react';
import { LandingPageHeader } from '@care/navigation';
import { Button } from '@material-ui/core';
import { EventNames, FEATURE_FLAGS, LoginLocation } from '@/constants';
import AppFooter from '@/components/shared/AppFooter';
import CareLogo from '@/components/shared/CareLogo';
import { useEventLogger } from '@/utilities/analyticsHelper';
import { useFlag } from '@/context/FeatureFlagsContext';
import useDirectEnrollmentData from '@/components/hooks/useDirectEnrollmentData';
import Hero from './components/Hero';

const Welcome: FC = () => {
  const logger = useEventLogger({
    user_flow: 'Direct to Enrollment',
  });
  const utmRedirectLdFlagResult = useFlag(FEATURE_FLAGS.ENT_UTM_REDIRECT_FLAG.key);
  const { update } = useDirectEnrollmentData();

  const handleLogin = () => {
    logger({
      name: EventNames.LOGIN,
      data: {
        login_location: LoginLocation.HEADER,
      },
    });
    window.location.href = `/vis/auth/login`;
  };

  useEffect(() => {
    update({
      utmRedirectFlagEnabled: utmRedirectLdFlagResult,
    });

    logger({
      name: EventNames.SCREEN_VIEWED,
      data: {
        step_name: 'Welcome',
        step_number: '0',
      },
    });
  }, []);

  const headerButton = (
    <Button color="secondary" variant="outlined" onClick={handleLogin}>
      Login
    </Button>
  );

  return (
    <>
      <LandingPageHeader button={headerButton} logo={<CareLogo />} />
      <Hero logger={logger} />
      <AppFooter whiteBackground />
    </>
  );
};

export default Welcome;
